import { CandidateCommunicationAlertsConst } from '@axiom/const';
import { z } from 'zod';
import { SchemaTimeOfDay, ZodArrayToEnum } from '@axiom/types';

const NOTIFICATION_TYPES = Object.keys(
  CandidateCommunicationAlertsConst.NotificationType
) as Array<keyof typeof CandidateCommunicationAlertsConst.NotificationType>;

const DAY_OF_WEEK = Object.keys(
  CandidateCommunicationAlertsConst.DayOfWeek
) as Array<keyof typeof CandidateCommunicationAlertsConst.DayOfWeek>;

const FREQUENCY = Object.keys(
  CandidateCommunicationAlertsConst.Frequency
) as Array<keyof typeof CandidateCommunicationAlertsConst.Frequency>;

export const CandidateCommunicationAlertsSchema = z.object({
  timezone: z.string(),
  communicationAlerts: z.object({
    timesheets: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
      timeSensitivePreferences: z.object({
        dayOfWeek: z.array(z.enum(ZodArrayToEnum(DAY_OF_WEEK))),
        frequency: z.array(z.enum(ZodArrayToEnum(FREQUENCY))),
        timeOfDay: SchemaTimeOfDay,
      }),
    }),
    interviews: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
    }),
    opportunitySuggestions: z.object({
      notificationType: z.enum(ZodArrayToEnum(NOTIFICATION_TYPES)),
    }),
    talentPartnerCommunications: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
    }),
    engagementStatus: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
    }),
    submissionStatus: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
    }),
    opportunityFeed: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
    }),
    axiomAnnouncements: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
    }),
    lessonlyReminderCommunications: z.object({
      optInEmail: z.boolean(),
      optInTextMessage: z.boolean(),
    }),
  }),
});

export type CandidateCommunicationAlerts = z.infer<
  typeof CandidateCommunicationAlertsSchema
>;
